import { computed, onMounted, watch } from 'vue';
import {
  STATES,
  SwrState,
  useActiveUserDocumentContract,
  useUserDocumentUsage,
  useUserInfo,
} from '@/utils/swr';
import { useUserDocumentLimitNotification } from '@/utils/user-document/userDocumentLimitNotification';
import { useStore } from '@/utils/vue';

export const useUserDocumentNotification = () => {
  const store = useStore();

  const { data: userInfo } = useUserInfo();
  const isAdminUser = computed(() => userInfo.value?.role === 'admin');
  const { data: userDocumentUsage, state: usageState } =
    useUserDocumentUsage(isAdminUser);
  const { data: activeUserDocumentContract, state: contractState } =
    useActiveUserDocumentContract(isAdminUser);

  const isSettled = (state: SwrState, data: unknown) =>
    state !== 'idle' &&
    state !== STATES.PENDING &&
    !(state === STATES.VALIDATING && data === undefined);

  const { refreshNotification } = useUserDocumentLimitNotification();
  const refresh = () => {
    if (userInfo.value === undefined) return;
    // 取得中の契約を「契約なし」と判定すると期限切れの通知が出て、社内情報ストレージの画面で閲覧済みにされてしまう
    if (
      isAdminUser.value &&
      (!isSettled(usageState.value, userDocumentUsage.value) ||
        !isSettled(contractState.value, activeUserDocumentContract.value))
    ) {
      return;
    }
    refreshNotification(
      isAdminUser.value,
      userDocumentUsage.value,
      activeUserDocumentContract.value,
    );
  };
  watch(
    [
      isAdminUser,
      userDocumentUsage,
      activeUserDocumentContract,
      usageState,
      contractState,
    ],
    refresh,
  );
  onMounted(refresh);

  const hasUserDocumentNotification = computed(
    () => store.state.userDocumentNotification.hasNotification,
  );

  return { isAdminUser, hasUserDocumentNotification };
};
